import React, { useEffect, useState } from 'react';

import MagneticButton from '../Miscellaneous/MagneticButton';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fetchAPI, postAPI } from '../../utils/api';
import SplitType from 'split-type';

import { contactData } from '../../data/mockData';
gsap.registerPlugin(ScrollTrigger);

const Form = () => {
  const contactInfo = {
    title: 'Get in Touch',
    description: 'We are here to help and answer any questions you might have.',
    phone: contactData.phone,
    email: contactData.email,
    address: contactData.address,
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // formData should contain keys matching your Strapi fields (e.g., name, email, message)
      const result = await postAPI('/contacts', formData);

      if (result) {
        alert("Message submitted successfully!");
        // Optional: Reset your form state here
      }
    } catch (error) {
      alert("Error sending message. Please check the console.");
    }
  };

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getGlobalData = async () => {
      try {
        // 1. Call /global (fetchAPI handles the /api prefix)
        // 2. Use populate: '*' to fetch all fields and components like socialLinks
        const response = await fetchAPI('/global', {
          populate: '*'
        });

        // 3. Strapi Single Types return data inside a 'data' object
        if (response.data) {
          // Option A: Set the whole data object (includes id and attributes)
          setData(response.data);

          // Option B: If you only want the field values (siteTitle, etc.):
          // setData(response.data.attributes);
        }
      } catch (error) {
        console.error("Error fetching Global Site Settings:", error);
      } finally {
        setLoading(false);
      }
    };

    getGlobalData();
  }, []);

  useEffect(() => {
    if (loading || !data) return;

    // Delay animations to ensure DOM is ready
    const timer = setTimeout(() => {
      const splitElements = document.querySelectorAll(".reveal-text");

      if (splitElements.length === 0) return;

      splitElements.forEach((element) => {
        // Only verify if element is visible and has content before trying to split
        if (element.textContent.trim().length > 0) {
          const text = new SplitType(element, { types: 'words, chars' });
          gsap.fromTo(
            text.chars,
            { color: "#B6BCC6" },
            {
              color: "#030712",
              scrollTrigger: {
                trigger: element,
                start: 'top 85%',
                end: 'top 20%',
                scrub: true,
              },
              stagger: 0.05,
            }
          );
        }
      });

      ScrollTrigger.refresh();
    }, 300);

    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [loading, data]);

  if (loading) return <div>Loading...</div>;
  if (!data) return null;

  return (
    <section className="contact-area primary-bg">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-4 order-last order-md-first">
            <div className="contact-info">
              <h3>{contactInfo.title}</h3>
              <p>{contactInfo.description}</p>

              <div className="content contact-form">
                <ul className="list-group list-group-flush">
                  {data.contactPhone &&
                    <li className="list-group-item">
                      <i className="icon icon-phone"></i>
                      <a className="content" href={`tel:${data.contactPhone}`}>{data.contactPhone}</a>
                    </li>}
                  {data.contactEmail &&
                    <li className="list-group-item">
                      <i className="icon icon-envelope-open"></i>
                      <a className="content" href={`mailto:${data.contactEmail}`}>{data.contactEmail}</a>
                    </li>}
                  {data.contactAddress &&
                    <li className="list-group-item">
                      <i className="icon icon-location-pin"></i>
                      <a className="content" href="/#">{data.contactAddress}</a>
                    </li>}
                </ul>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-7 order-first order-md-last mt-sm-4 mt-lg-0">
            <form id="contact-form" className="contact-form" onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                <label htmlFor="name">Name</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="name@example.com"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <label htmlFor="email">Email address</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="number"
                  className="form-control"
                  id="phone"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                />
                <label htmlFor="phone">Phone</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  placeholder="Company Name"
                  value={formData.company}
                  onChange={handleInputChange}
                />
                <label htmlFor="company">Company Name</label>
              </div>{/*
              <div className="form-floating mb-3">
                <input
                  type="url"
                  className="form-control"
                  id="website"
                  placeholder="Company Website"
                  value={formData.website}
                  onChange={handleInputChange}
                />
                <label htmlFor="website">Company Website</label>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">I'm interested in:</div>
                <div className="form-input-group">
                  {['Branding', 'Web Design', 'App Design', 'Other'].map((option) => (
                    <div className="form-input" key={option}>
                      <input
                        type="radio"
                        className="btn-check"
                        name="interest"
                        id={`option-${option.toLowerCase()}`}
                        value={option}
                        onChange={handleInputChange}
                      />
                      <label className="btn magnetic-button btn-outline" htmlFor={`option-${option.toLowerCase()}`}>
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="form-group mb-3">
                <div className="form-label">My budget is:</div>
                <div className="form-input-group">
                  {['< 2k', '2-5k', '5-10k', '10-15k', '> 20k'].map((budget) => (
                    <div className="form-input" key={budget}>
                      <input
                        type="radio"
                        className="btn-check"
                        name="budget"
                        id={`budget-${budget.replace(' ', '-')}`}
                        value={budget}
                        onChange={handleInputChange}
                      />
                      <label className="btn magnetic-button btn-outline" htmlFor={`budget-${budget.replace(' ', '-')}`}>
                        {budget}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="exact-budget"
                  placeholder="Exact Budget"
                  value={formData.budget}
                  onChange={handleInputChange}
                />
                <label htmlFor="exact-budget">Do you have an exact budget?</label>
              </div>
              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  id="timeline"
                  placeholder="Timeline"
                  value={formData.timeline}
                  onChange={handleInputChange}
                />
                <label htmlFor="timeline">What is your timeline?</label>
              </div>*/}
              <div className="form-floating mb-4">
                <textarea
                  className="form-control"
                  id="message"
                  placeholder="Leave a comment here"
                  style={{ height: '100px' }}
                  value={formData.message}
                  onChange={handleInputChange}
                />
                <label htmlFor="message">Message</label>
              </div>
              <MagneticButton type="submit">
                Submit Message
              </MagneticButton>
            </form>
            <p className="form-message"></p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Form;
